import { render } from "./ActivateDeactivateEmployee.vue?vue&type=template&id=d9c23f24"
import script from "./ActivateDeactivateEmployee.vue?vue&type=script&lang=js"
export * from "./ActivateDeactivateEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__